import React from "react";
import { withStyles } from "@material-ui/core";
import StyledToolTip from "../StyledToolTip";

interface MergeIndicatorTheme {
  iconColor?: string;
}

const styles = (theme: MergeIndicatorTheme) => ({
  icon: {
    marginLeft: 4,
    fontSize: 14,
    color: theme.iconColor,
    verticalAlign: "middle",
  },
});

interface CustomerMergeIndicatorProps {
  classes: Record<string, string>;
  displayCustomerName?: string;
  customerName?: string;
  color?: string;
}

const CustomerMergeIndicator = ({
  classes,
  displayCustomerName,
  customerName,
  color,
}: CustomerMergeIndicatorProps) => {
  if (!displayCustomerName || !customerName || displayCustomerName === customerName) {
    return null;
  }
  return (
    <StyledToolTip
      title={
        <>
          <b>MERGED CUSTOMER</b>
          <div>{`Merged with ${customerName}`}</div>
        </>
      }
    >
      <i
        className={`icon-merge-routes ${classes.icon}`}
        style={color ? { color } : undefined}
      />
    </StyledToolTip>
  );
};

export default withStyles(
  styles as unknown as Parameters<typeof withStyles>[0]
)(CustomerMergeIndicator);
